export enum DirectoryTrackingEvent {
  DirectoryViewed = 'Directory Viewed',
  DirectoryPhoneNumberClicked = 'Directory Phone Number Clicked',
  DirectoryProfileViewed = 'Directory Profile Viewed',
  DirectoryProviderClicked = 'Directory Provider Clicked',
  DirectorySearched = 'Directory Searched',
}

export type CareType = 'careHome' | 'homeCare';

export interface Address {
  streetAddress1?: string;
  streetAddress2?: string;
  streetAddress3?: string;
  streetAddress4?: string;
  city?: string;
  district?: string;
  county?: string;
  region?: string;
  constituentCountry?: string;
  country?: string;
  postcode?: string;
  districtType?: string;
}

export interface Location {
  lat: number;
  lng: number;
}

export type RatingsValuesTypeCi =
  | 'excellent'
  | 'veryGood'
  | 'good'
  | 'adequate'
  | 'weak'
  | 'unsatisfactory'
  | 'notPublished';

export type RatingsValuesTypeCqc =
  'outstanding' | 'good' | 'requiresImprovement' | 'inadequate';

export interface RatingsTypeCi {
  overallRating?: RatingsValuesTypeCi;
  supportWellbeing?: RatingsValuesTypeCi;
  leadership?: RatingsValuesTypeCi;
  staffTeam?: RatingsValuesTypeCi;
  setting?: RatingsValuesTypeCi;
  careAndSupportPlanning?: RatingsValuesTypeCi;
}

export interface RatingsTypeCqc {
  overallRating?: RatingsValuesTypeCqc;
  caring?: RatingsValuesTypeCqc;
  effective?: RatingsValuesTypeCqc;
  responsive?: RatingsValuesTypeCqc;
  safe?: RatingsValuesTypeCqc;
  wellLed?: RatingsValuesTypeCqc;
}

export type RatingsType = RatingsTypeCi | RatingsTypeCqc;

export type RatingDimension<T> = {
  key: keyof Omit<T, 'overallRating'>;
  label: string;
};

export const CQC_DIMENSIONS: RatingDimension<RatingsTypeCqc>[] = [
  { key: 'safe', label: 'Safe' },
  { key: 'effective', label: 'Effective' },
  { key: 'caring', label: 'Caring' },
  { key: 'responsive', label: 'Responsive' },
  { key: 'wellLed', label: 'Well-led' },
];

export const CI_DIMENSIONS: RatingDimension<RatingsTypeCi>[] = [
  { key: 'supportWellbeing', label: 'Support & wellbeing' },
  { key: 'leadership', label: 'Leadership' },
  { key: 'staffTeam', label: 'Staff team' },
  { key: 'setting', label: 'Setting' },
  { key: 'careAndSupportPlanning', label: 'Care & support planning' },
];

export interface ImageType {
  tiny?: string;
  small?: string;
  medium?: string;
  large?: string;
}

export interface MinimumVisitTime {
  time?: number;
  label?: string;
}

export interface ProviderType {
  id?: string;
  regulatoryId: string;
  regulator: string;
  careType?: CareType;
  dateOpened?: string;
  enquiryEmail?: string;
  localAuthorityId?: number;
  managerName?: string;
  name: string;
  purposeBuilt?: boolean;
  regulatoryStatus?: string;
  website?: string;
  availability?: boolean;
  pricePerWeek?: number;
  enquiryPhone?: string;
  description?: string;
  managerQuote?: string;
  distance?: number;
  bedCount?: number;
  doubleBedCount?: number;
  enSuiteRoomCount?: number;
  address?: Address;
  careServiceTypes?: string[];
  coverPhoto?: ImageType;
  photos?: ImageType[];
  ratings?: RatingsType;
  specialisms?: string[];
  location?: Location;
  hourlyRate?: number;
  minimumVisitTime?: MinimumVisitTime;
}

export type RegulatorType = 'ci' | 'cqc';

export interface ProviderNote {
  id: string;
  regulatoryId: string;
  accountId: string;
  author: string;
  text: string;
  createdAt: string;
  updatedAt: string;
}
